import axios from "axios";

export function fetchShops() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/bulk`
  };
  return axios(config);
}

export function fetchRetailShops() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/bulk?type=retail`
  };
  return axios(config);
}

export function fetchShopInfo(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}`
  };
  return axios(config);
}

export function fetchShopEdit(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}`
  };
  return axios(config);
}

export function fetchSiAccounts() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/si-accounts`
  };
  return axios(config);
}

export function fetchQrcode(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}/qrcode`
  };
  return axios(config);
}

export function fetchRichmenus() {
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/richmenus`
  };
  return axios(configBusiness);
}

export function fetchContract(data) {
  let accountId = data.accountId;
  let businessId = data.businessId;
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/contract?businessId=${businessId}`
  };
  return axios(configBusiness);
}

export function fetchPlans() {
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/contract/plans`
  };
  return axios(config);
}

export function fetchPromotions(data) {
  let businessId = data.businessId;
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${businessId}/promotions`
  };
  return axios(config);
}


